import React from "react";
import { useState } from "react";
import "./AcceptModal.css";

interface AcceptModalProps {
    onAccept: Function;
    imgType: string;
    canBuffer? : boolean;
    className?: string;
    style?: any;
    acceptDefaultColor?: string;
    direction?: "up" | "right" | "down" | "left";
}

export default function AcceptModal(props : AcceptModalProps) {
    let dir = props.direction || "left";
    const [show, setShow] = useState<boolean>(false);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const onAccept = (e : any) => {
        e.stopPropagation();
        props.canBuffer && setIsLoading(true);
        
        setShow(false);
        props.onAccept();
    }

    return <span className='accept-modal-container' style={props.style}>

        {isLoading && <i className={"fas fa-spinner accept-modal-spinner"}/>}

        {!show && !isLoading && <i className={"fas fa-" + props.imgType + " accept-modal-button base " + props.className} onClick={(e) => {e.stopPropagation(); setShow(true)}}/>}

        {show && !isLoading && <span className='d-flex'><i className={`fas fa-check accept-modal-button accept me-1 slide-${dir}`} onClick={onAccept} style={props.acceptDefaultColor ? {backgroundColor: props.acceptDefaultColor} :{}}/>
        <i className="fas fa-times accept-modal-button cancel" onClick={(e) => {e.stopPropagation(); setShow(false)}}/></span>}
        </span>
}
